import Timer from './Timer';

export default new Timer();


// WEBPACK FOOTER //
// ./src/modules/dro/timer/index.js